// @ts-check
import { get, filter, find, map } from "lodash";
import { ADMIN_ROLE } from "src/services/auth";
import { PROJECT_PREFILL_OPTIONS } from "../consts";

const FORECAST_READONLY_MESSAGE_FIELDS = [
  "requestorForecastReadonlyBanner",
  "requestorForecastReadonlyHover",
  "approverForecastReadonlyBanner",
  // `approverForecasteadonlyHover` is misspelled in the GraphQL API contract.
  "approverForecasteadonlyHover",
];

const applyActiveForecastReadonlyMessages = (
  allocationProject,
  activeAllocationProject
) => {
  if (
    !activeAllocationProject ||
    allocationProject.isActive ||
    !allocationProject.forecast
  ) {
    return allocationProject;
  }

  const inheritedReadonlyMessages = {};
  FORECAST_READONLY_MESSAGE_FIELDS.forEach((fieldName) => {
    if (activeAllocationProject[fieldName] !== undefined) {
      inheritedReadonlyMessages[fieldName] = activeAllocationProject[fieldName];
    }
  });

  return {
    ...allocationProject,
    ...inheritedReadonlyMessages,
  };
};

export const getForecastAllocationProjects = (allocationProjects) => {
  const forecastAllocationProjects = filter(
    allocationProjects,
    (ap) => !ap.isDeleted && (ap.isActive || ap.forecast)
  );
  const activeAllocationProject = find(forecastAllocationProjects, "isActive");

  return map(forecastAllocationProjects, (ap) => {
    const allocationProject = {
      ...ap,
      // Preserve the existing fallback without mutating source allocation projects.
      prefillOption: ap.prefillOption || PROJECT_PREFILL_OPTIONS.TODAY,
    };

    return applyActiveForecastReadonlyMessages(
      allocationProject,
      activeAllocationProject
    );
  });
};

export const getForecastReadonlyFlag = (
  allocationProject,
  rootGroup,
  userRole
) => {
  // Missing project data cannot prove the period is unlocked — stay readonly.
  if (!allocationProject) {
    return true;
  }

  const isDemand = get(rootGroup, "isDemand", false);
  if (isDemand) {
    const isReadonly = get(
      allocationProject,
      "isRequestorForecastReadonly",
      false
    );
    if (isReadonly && userRole === ADMIN_ROLE) {
      return false;
    }
    return isReadonly;
  }

  const isSource = get(rootGroup, "isSource", false);
  if (isSource) {
    const isReadonly = get(
      allocationProject,
      "isApproverForecastReadonly",
      false
    );
    if (isReadonly && userRole === ADMIN_ROLE) {
      return false;
    }
    return isReadonly;
  }

  return false;
};

export const getForecastReadonlyMsg = (allocationProject, rootGroup) => {
  const isDemand = get(rootGroup, "isDemand", false);
  if (isDemand) {
    return get(allocationProject, "requestorForecastReadonlyHover", "");
  }

  const isSource = get(rootGroup, "isSource", false);
  if (isSource) {
    return get(allocationProject, "approverForecasteadonlyHover", "");
  }

  return "";
};

export const getIndirectForecastFlg = (groupTypes, group) => {
  const groupType = get(groupTypes, group.type, {});

  return get(groupType, "planning.canHaveIndirectPlaceholderForecasts", false);
};

export const getIndirectForecastTargetFlg = (groupTypes, group) => {
  const groupType = get(groupTypes, group.type, {});

  return get(groupType, "planning.isIndirectPlaceholderForecastTarget", false);
};
